export default "__VITE_ASSET__e4647487__"